import * as React from "react";
import { FC } from "react";
import "./CloseButton.scss";

export interface ICloseButton {
    onClose: () => void;
}
export const CloseButton: FC<ICloseButton> = (props) => (
    <a role="button" className="close-button unselectable" onClick={() => props.onClose()}>
        <span className="icon-zemesnoma-close-popup"></span>
    </a>
);
